import React from 'react';
import type { ApolloError } from 'apollo-client';
import { FlagRenderer } from '@atlassian/jira-flags';
import { getErrorFlag } from '@atlassian/jira-software-swag/src/services/error-to-flag/index.tsx';

type Props = {
	error: ApolloError;
};

export const FlagFromError = ({ error }: Props) => <FlagRenderer flag={getErrorFlag(error)} />;
